/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier1Icon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA7klEQVR4nGNgGCzA3z/cwS8g4h4Ig9hUNdw3IDzN1z/8l19AxH8o/u3rH15OscH29vYsfgHhk5AMRsG+/uGzQkND2cgyPDAwRsw3IOIQmoEnQRhFLCDiEEgtSYb7+4cr+AVEPERxsX/4Yvv4eA4QBrHRfPPQ1zdUkWgLfAPCNyJcHfHHLyC8FF0NSAwiB/NJ+GqiLfALiPiKpNEHj0N8ED6MeE6KBXDvM1BR7agF/0eDaCilIv+I5yRntIDwL6RYsJaMomId0RZ4B0UpkVrYeQVFyTMMmuKaLhUOXapMBiQAquh9/SPugDDVK31KAABjuTdj8mu6kAAAAABJRU5ErkJggg==)
 */
export const BoostTier1Icon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M13.05 1.4a1.59 1.59 0 0 0-2.1 0l-4.9 4A3.37 3.37 0 0 0 5 8v8c0 1.07.4 2.06 1.05 2.6l4.9 4c.65.53 1.45.53 2.1 0l4.9-4A3.37 3.37 0 0 0 19 16V8c0-1.07-.4-2.06-1.05-2.6l-4.9-4ZM12 4.41 8.06 7.64c-.03.08-.06.2-.06.36v8c0 .16.03.28.06.36L12 19.59l3.94-3.23c.03-.08.06-.2.06-.36V8c0-.16-.03-.28-.06-.36L12 4.41Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
